const styles = theme => {
  // take mobile-first approach to do the styling

  const minMd = theme.breakpoints.up('md');

  return {
    formGroup: {
      marginBottom: 20,
    },
    actionsRow: {
      marginTop: 0,
      padding: '20px 20px 20px 20px',
      [minMd]: {
        padding: '40px 40px 40px 40px',
      },
    },
    inner: {
      [minMd]: {
        display: 'flex',
      },
    },
    leftPanel: {
      [minMd]: {
        display: 'block',
        width: '60%',
      },
    },
    leftPanelContent: {
      padding: '5px 20px 10px 20px',
      [minMd]: {
        padding: '40px 40px 40px 40px',
      },
    },
    rightPanel: {
      width: '100%',
      [minMd]: {
        width: '50%',
      },
    },
    rightPanelContent: {
      padding: '0px 20px 20px 20px',
      [minMd]: {
        padding: '40px 40px 40px 40px',
      },
    },
  };
};

export default styles;
